import { AccountResource } from '@datarock/api-client';
import AsyncBoundary from '../../AsyncBoundary';
import { IOrganizationAccountRouteParams } from '../../../routing';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useSuspense } from '@data-client/react';

function ErrorMessage() {
  return <span>Error</span>;
}

function Loader() {
  return <span>...</span>;
}

const AccountName: React.FC<
  RouteComponentProps<IOrganizationAccountRouteParams>
> = (props) => {
  const { accountId } = props.match.params;

  const account = useSuspense(
    AccountResource.get,
    accountId === 'add'
      ? null
      : {
          id: accountId
        }
  );

  if (!account) {
    return null;
  }

  return <span>{account.email}</span>;
};

const OrganizationBreadcrumb: React.FC<
  RouteComponentProps<IOrganizationAccountRouteParams>
> = (props) => {
  return (
    <AsyncBoundary errorFallback={ErrorMessage} loadingFallback={Loader}>
      <AccountName {...props} />
    </AsyncBoundary>
  );
};

export default OrganizationBreadcrumb;
